import axios from "axios";
import { useQuery } from "react-query";
import instance from "./config";

const instanceNoAuth = axios.create({ baseURL: process.env.REACT_APP_BACKEND_URL });
instanceNoAuth.interceptors.response.use((response) => response?.data);

/** { programs, products } — chương trình đang chạy + ảnh chụp SP liên quan (public) */
export const getActivePromotions = async () => instanceNoAuth.get("/promotion/get-active");

export const getAllPromotions = async () => instance.get("/promotion/get-all");
export const createPromotion = async (body) => instance.post("/promotion/create", body);
export const updatePromotion = async (body) => instance.put("/promotion/update", body);
export const deletePromotion = async (id) => instance.delete("/promotion/delete", { params: { id } });

const EMPTY = { programs: [], products: {} }; // hằng số → useMemo phía dùng không chạy lại mỗi lần render

/** Chương trình khuyến mãi đang chạy (giỏ hàng, giỏ mini, trang SP) — cache 60s, dùng chung 1 request. */
export const useActivePromotions = () =>
  useQuery("activePromotions", getActivePromotions, { refetchOnWindowFocus: false, staleTime: 60000 }).data ?? EMPTY;
